import {NgModule} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {SharedModule} from 'app/shared/shared.module';
import {UserOnboardingModalComponent} from './user-onboarding-modal.component';
import {MatChipsModule} from '@angular/material/chips';
import {CountrySearchSelectorComponent} from 'app/shared/country-search-selector/country-search-selector.component';

@NgModule({
  declarations: [UserOnboardingModalComponent],
  imports: [
    MatDialogModule,
    SharedModule,
    MatChipsModule,
    CountrySearchSelectorComponent,
  ],
  providers: [],
})

export class UserOnboardingModalModule {
}
